import { Controller } from "@hotwired/stimulus";
import { formattedSeconds } from "../utils/date_utils";
import { handleHttpResponse } from "../utils/http_utils";
import { notifyError } from "../components/flash_alert";

export default class extends Controller {
  static targets = ["mobileValidationForm", "sendSmsButton", "timeLeftCounter", "sendingSmsLockedElement"];

  connect() {
    this.mobileValidationFormTarget.classList.add("hidden");
  }

  onPhoneCodeSent(e) {
    handleHttpResponse({
      payload: e.detail[0],
      onSuccess: () => {
        this._handleSmsIntervalDelay();
        this.mobileValidationFormTarget.classList.remove("hidden");
        this.mobileValidationFormTarget.classList.add("fade-in-top");
      },
      onError: (response) => {
        const message = JSON.parse(response).message;
        notifyError(message);
      },
    });
  }

  _handleSmsIntervalDelay() {
    let secondsLeft = 60;
    this._lockSmsButton(secondsLeft);
    secondsLeft--;

    const countdown = setInterval(() => {
      this._displayTimeLeft(secondsLeft);
      secondsLeft--;

      if (secondsLeft < 0) {
        clearInterval(countdown);
        this._unlockSmsButton();
      }
    }, 1000);
  }

  _lockSmsButton(secondsLeft) {
    this._displayTimeLeft(secondsLeft);
    this.sendSmsButtonTarget.disabled = true;
    this.sendingSmsLockedElementTarget.classList.remove("hidden");
  }

  _unlockSmsButton() {
    this._removeTimeLeft();
    this.sendSmsButtonTarget.disabled = false;
    this.sendingSmsLockedElementTarget.classList.add("hidden");
  }

  _displayTimeLeft(secondsLeft) {
    this.timeLeftCounterTarget.innerHTML = `${formattedSeconds(secondsLeft)}`;
  }

  _removeTimeLeft() {
    this.timeLeftCounterTarget.innerHTML = "";
  }
}
